module.exports = __webpack_public_path__ + "assets/ic_tree31.d425f8de.svg";